import PropTypes from 'prop-types';

function IFWineActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11312)">
                <path
                    d="M17.7339 3.06412C20.3621 3.51086 22.5455 3.56196 22.6107 3.17826C22.6759 2.79456 20.5983 2.12136 17.9701 1.67462C15.342 1.22788 13.1586 1.17677 13.0933 1.56048C13.0281 1.94418 15.1058 2.61738 17.7339 3.06412Z"
                    fill="#F4F0F2"
                />
                <path
                    d="M13.0927 1.56065C13.0927 1.56065 9.52638 5.76106 10.0388 9.46011C10.5512 13.1592 14.1537 14.0565 14.2964 15.1742C14.4391 16.292 14.7895 17.5869 14.2169 20.6752C13.6442 23.7635 13.181 26.4888 12.8796 26.8656C12.5777 27.2424 11.5715 27.8478 10.1416 27.5926C9.16894 27.4191 8.87598 27.6746 8.57105 28.1614C8.39613 28.4411 10.5812 29.058 13.4786 29.5557C16.3732 30.053 18.4547 30.2352 18.4472 29.999C18.4396 29.7627 18.1462 28.7857 16.8743 28.7236C16.3102 28.6958 15.4346 28.3067 15.018 27.9899C14.3967 27.5179 14.1201 26.8392 14.2929 25.8228C14.4656 24.8064 15.2303 19.4696 15.7664 17.992C16.3026 16.5145 16.7248 15.7109 17.6568 15.261C18.5889 14.811 21.0613 14.2576 22.1244 12.9371C23.0313 11.8111 23.4098 10.782 23.3649 7.9697C23.3201 5.15744 22.6105 3.17967 22.6105 3.17967"
                    fill="#DBF3F5"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5084 6.78182C11.3195 6.84918 10.6356 8.85064 11.2915 10.3057C12.0038 11.8844 13.2686 13.0183 15.7537 13.314C18.2388 13.6096 20.3982 13.0257 21.1206 11.9445C21.843 10.8633 22.1306 9.35924 22.1725 9.11276C21.58 9.24179 20.0788 10.0562 17.7963 9.12967C15.5139 8.2031 14.7463 5.6321 11.5084 6.78182Z"
                    fill="#D9291F"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11312">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.584961)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFWineActive;

IFWineActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFWineActive.defaultProps = {
    className: null,
    width: 28,
};
